import { Injectable } from '@angular/core';
import { firstValueFrom } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { ApiService } from '../api/api.service';
import {
  SendRemoteHealthModel,
  SendRemoteHealthResponse,
} from '../../models/remote-health/remote-health.model';
import { BaseApiResponse } from '../../models/api/api.model';

@Injectable({
  providedIn: 'root',
})
export class RemoteHealthService {
  constructor(private apiService: ApiService) {}

  async sendRemoteHealth(
    command: SendRemoteHealthModel
  ): Promise<BaseApiResponse<SendRemoteHealthResponse>> {
    return await firstValueFrom(
      this.apiService.post<SendRemoteHealthResponse>(
        `${environment.apiLocations.patient}/patients/sys/remote-health`,
        command
      )
    );
  }
}
